import { IconProps } from '../../Icon.types';

export const Businesstrip3DIcon = ({ width, height, color }: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="nan"
        height="nan"
        transform="translate(10 10)"
        fill="#8E8E8E"
      />
      <g filter="url(#filter0_i_3982_59702)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.4888 9.86037C39.3097 9.20381 38.7968 8.6909 38.1402 8.51184C37.1016 8.22859 35.9903 8.4931 35.1907 9.21387L29.6103 14.2439C28.5051 15.2401 26.9502 15.5665 25.5377 15.0989L14.6708 11.5012C13.5942 11.1448 12.4086 11.426 11.6066 12.2279L10.9794 12.8551C10.6886 13.1459 10.7699 13.6363 11.1389 13.8178L19.9811 18.1659C21.8262 19.0732 22.2325 21.5255 20.7786 22.9793L16.3759 27.3821C15.5138 28.2441 14.3197 28.6891 13.1037 28.6013L6.65523 28.136C6.41914 28.1189 6.30394 28.1836 6.23778 28.2371C6.15156 28.3068 6.066 28.4311 6.0272 28.6004C5.9884 28.7698 6.0113 28.919 6.05857 29.0192C6.09484 29.0962 6.17041 29.2045 6.39036 29.292L13.5231 32.1279C14.5958 32.5544 15.4456 33.4036 15.873 34.4759L18.7198 41.6198C18.8074 41.8398 18.9159 41.9152 18.9928 41.9514C19.0932 41.9986 19.2424 42.0214 19.4118 41.9824C19.5811 41.9434 19.7054 41.8576 19.775 41.7713C19.8284 41.7051 19.8929 41.5899 19.8755 41.3537L19.4011 34.9012C19.3115 33.6833 19.7565 32.4868 20.6199 31.6233L25.0213 27.222C26.4751 25.7681 28.9274 26.1744 29.8347 28.0195L34.1828 36.8617C34.3643 37.2307 34.8547 37.312 35.1455 37.0212L35.7727 36.394C36.5746 35.5921 36.8558 34.4064 36.4994 33.3298L32.9017 22.463C32.4341 21.0504 32.7605 19.4955 33.7567 18.3903L38.7867 12.81C39.5075 12.0103 39.772 10.899 39.4888 9.86037ZM39.0875 5.03869C40.9738 5.55315 42.4475 7.0268 42.9619 8.91315C43.5676 11.134 43.002 13.5104 41.4608 15.2203L36.4308 20.8006C36.3009 20.9447 36.2583 21.1474 36.3193 21.3315L39.9169 32.1984C40.7011 34.567 40.0825 37.1753 38.3183 38.9396L37.6911 39.5668C35.6557 41.6022 32.2225 41.0334 30.9523 38.4503L26.9741 30.3603L23.1655 34.1689C23.0422 34.2923 22.9786 34.4632 22.9914 34.6372L23.4658 41.0897C23.8181 45.8798 17.1536 47.4143 15.3755 42.9525L12.5287 35.8086C12.4677 35.6554 12.3463 35.5341 12.193 35.4732L5.06031 32.6373C0.598364 30.8632 2.12507 24.1997 6.91434 24.5453L13.3629 25.0107C13.5366 25.0232 13.7072 24.9596 13.8303 24.8365L17.6403 21.0265L9.55032 17.0483C6.96727 15.7782 6.39844 12.3449 8.43383 10.3095L9.06103 9.68232C10.8253 7.91806 13.4336 7.2995 15.8023 8.08367L26.6691 11.6813C26.8532 11.7423 27.0559 11.6997 27.2 11.5698L32.7803 6.53985C34.4902 4.99862 36.8666 4.43301 39.0875 5.03869Z"
          fill={color}
        />
      </g>
      <defs>
        <filter
          id="filter0_i_3982_59702"
          x="1.4043"
          y="4.80029"
          width="41.7969"
          height="41.8052"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.211765 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_3982_59702"
          />
        </filter>
      </defs>
    </svg>
  );
};
